import React from "react";

/* eslint-disable max-len */
export default function NewIcon() {
	return (
		<svg version="1.1" id="レイヤー_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px"
			y="0px" viewBox="0 0 142.33 142.33" enableBackground="new 0 0 142.33 142.33" xmlSpace="preserve">
			<polygon fill="#D1161B" points="54.98,0 0,54.98 0,142.33 142.33,0 " />
			<path fill="#FFFFFF" d="M13.25,68.25l21.93,5.11l0.06-0.06L21.72,59.79l4.15-4.15l20.15,20.15l-4.43,4.43l-21.87-5.11l-0.06,0.06
	l13.49,13.49L29,92.81L8.85,72.66L13.25,68.25z"/>
			<path fill="#FFFFFF" d="M44.83,36.68l3.73,3.73L37.92,51.04l4.32,4.32L52,45.59l3.44,3.44l-9.76,9.76l4.94,4.94l10.86-10.86
	l3.73,3.73l-15.3,15.3L29.76,51.75L44.83,36.68z"/>
			<path fill="#FFFFFF" d="M82.99,38.82l-17.13-10.3l-0.06,0.06l10.36,17.07l-4.49,4.49L46.19,35.32l4.43-4.43l16.9,10.53l0.06-0.06
	L57.36,24.15L61.51,20l17.33,10.44l0.06-0.06L68.31,13.2l4.35-4.35l14.73,25.57L82.99,38.82z"/>
		</svg>
	);
}
